import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from 'react-query';

import App from '@/app/App';
import { store } from '@/app/store';
import { ThemeProvider } from '@/theme';
import { ConnectionThemesSync } from '@/theme/ConnectionThemesSync';
import { AuthProvider } from '@/app/providers/AuthProvider';
import { ConnectionProvider } from '@/app/contexts/ConnectionContext';
import { DensityProvider } from '@/shared/density/DensityProvider';
import { PreferencesGate } from '@/app/preferences/PreferencesGate';

import './i18n';
import './index.css';

// Create React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ThemeProvider>
            <AuthProvider>
              <ConnectionProvider>
                <ConnectionThemesSync />
                <PreferencesGate>
                  <DensityProvider>
                    <App />
                  </DensityProvider>
                </PreferencesGate>
              </ConnectionProvider>
            </AuthProvider>
          </ThemeProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>
);




